<template>
  <div class="c-budget-picker">
    <button class="c-budget-picker__toggle" @click="toggleMenu">
      <div class="c-budget-picker__toggle__label">{{ selectedLabel }}</div>
      <o-icon icon="triangle-down" class="c-budget-picker__toggle__caret" />
    </button>
    <div
      class="c-budget-picker__list"
      :class="{ 'c-budget-picker__list--open': isOpen }"
    >
      <button
        class="c-budget-picker__list__item"
        v-for="budget in budgets"
        :key="budget.label"
        @click="selectBudget(budget)"
      >
        <o-icon
          icon="check"
          class="c-budget-picker__list__check"
          v-if="budget.selected"
        />
        <span class="c-budget-picker__list__label">{{ budget.label }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import OIcon from '@/components/base/OIcon.vue'
export default {
  name: 'OBudgetPicker',
  components: { OIcon },
  data: () => ({
    isOpen: false,
    budgets: [
      {
        label: 'Privé',
        selected: true
      },
      {
        label: 'Werk',
        selected: false
      },
      {
        label: 'Mobiliteitsbudget',
        selected: false
      }
    ]
  }),
  computed: {
    selectedLabel() {
      return this.budgets.find(budget => budget.selected).label
    }
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
    },
    selectBudget(budget) {
      this.budgets.forEach(budget => (budget.selected = false))
      budget.selected = true
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss">
.c-budget-picker {
  position: relative;
  z-index: 20;
}

.c-budget-picker__toggle {
  align-items: center;
  appearance: none;
  background: #fff;
  box-shadow: $box-shadow;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  padding: 1.2rem 1.6rem;
  width: 100%;
}

.c-budget-picker__toggle__label {
  font-size: 1.6rem;
  font-weight: 500;
  line-height: 1.6rem;
}

.c-budget-picker__toggle__caret {
  margin-left: auto;

  svg * {
    fill: $gray-500;
  }
}

.c-budget-picker__list {
  background: #fff;
  box-shadow: $box-shadow-large;
  left: 0;
  opacity: 0;
  padding: 0.8rem 0;
  pointer-events: none;
  position: absolute;
  right: 0;
  top: 100%;
  transition: opacity 0.1s linear;
}

.c-budget-picker__list--open {
  opacity: 1;
  pointer-events: auto;
}

.c-budget-picker__list__item {
  align-items: center;
  appearance: none;
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  padding: 1.6rem 1.6rem 1.6rem 4.8rem;
  position: relative;
  width: 100%;

  &:hover {
    font-weight: bold;
  }
}

.c-budget-picker__list__check {
  left: 1.6rem;
  position: absolute;
  top: 1.2rem;

  svg * {
    fill: $primary-color;
    fill: var(--primary-color);
  }
}
</style>
